import { html } from 'lit';
const SettingsPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.473 5.08c.178.178.42.278.671.278h2.549c.524 0 .949.425.949.949v2.549c0 .252.1.493.278.67l1.802 1.803c.37.37.37.971 0 1.342l-1.802 1.802a.95.95 0 0 0-.278.671v2.55a.95.95 0 0 1-.949.948h-2.549a.95.95 0 0 0-.67.278l-1.803 1.802a.95.95 0 0 1-1.342 0L9.527 18.92a.95.95 0 0 0-.671-.278H6.307a.95.95 0 0 1-.949-.949v-2.549c0-.251-.1-.493-.278-.67L3.278 12.67a.95.95 0 0 1 0-1.342L5.08 9.527a.95.95 0 0 0 .278-.671V6.307c0-.524.425-.949.949-.949h2.549c.252 0 .493-.1.67-.278l1.803-1.802a.95.95 0 0 1 1.342 0zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clip-rule="evenodd"/>
  </svg>
`;
export default SettingsPanel;
